<template>
  <section id="componentDisplay" ref="componentDisplay">
    <component
      :is="blockComponents[component.layout]"
      v-for="(component, idx) in components"
      :key="component.layout + idx"
      v-bind="{ component }"
      :use-schema-tags="false"
    />
  </section>
</template>

<script lang="ts">
/**
 * This component is changed name from Component.vue to ComponentWrapper
 */
import { defineComponent } from 'vue';
import BlockComponents from '~/constants/block-components';

export default defineComponent({
  name: 'ComponentWrapper',
  props: {
    components: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      blockComponents: BlockComponents,
    };
  },
});
</script>

<style scoped>
</style>
